import { AEMSvg, AEMSvgData } from "@components/AEMSvg"
import { Card, Divider, Flex, Text, rem, useMantineTheme } from "@mantine/core"
import styles from "./InfoCard.module.css"

export interface InfoCardProps {
	icon?: AEMSvgData | string
	count?: number
	label?: string
	isFirst?: boolean
	isLast?: boolean
}

export function InfoCard({ icon, label, count }: InfoCardProps) {
	const theme = useMantineTheme()
	return (
		<Card
			withBorder
			py="md"
			px={32}
			radius={theme.radius.infoCard}
			className={styles.infocard}
		>
			<Flex direction="column" w="100%" gap="sm" p="4px">
				<Flex gap="md" align="center" mih={rem(18)}>
					{icon && (
						<AEMSvg
							svgData={{
								path: icon as string,
								iconColor: theme.colors.royal[5]
							}}
							w={label === "Schedule Payments" ? 45 : 21}
							data-icon-type="original"
							ariaLabel={`${label} Icon`}
						/>
					)}
					{count !== undefined && (
						<>
							<Divider
								color="var(--mantine-color-royal-24)"
								orientation="vertical"
								className={styles.divider}
							/>
							<Text
								className={styles.count}
								fz={22}
								fw={600}
								lh={0.9}
								c={theme.colors.royal[5]}
							>
								{count}
							</Text>
						</>
					)}
				</Flex>
				<Text
					className={styles.title}
					fz={{ base: 14, md: 16 }}
					fw={500}
					lh={1.3}
					c={theme.colors.royal[5]}
				>
					{label}
				</Text>
			</Flex>
		</Card>
	)
}
